import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { generateAvatarColor } from '../utils/avatarColor';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,        setUser]        = useState(null);
  const [avatarColor, setAvatarColor] = useState(null);
  const [loading,     setLoading]     = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('sms_token');
    const saved = localStorage.getItem('sms_user');
    if (token && saved) {
      setUser(JSON.parse(saved));
      setAvatarColor(localStorage.getItem('sms_avatar_color_v2') || generateAvatarColor());
    }
    setLoading(false);
  }, []);

  const login = useCallback(async (username, password) => {
    const res = await api.post('/auth/login', { username, password });
    const { token, user: u } = res.data;
    const color = generateAvatarColor();
    localStorage.setItem('sms_token', token);
    localStorage.setItem('sms_user',  JSON.stringify(u));
    localStorage.setItem('sms_avatar_color_v2', color);
    setUser(u);
    setAvatarColor(color);
    return u;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post('/auth/logout'); } catch (_) {}
    localStorage.removeItem('sms_token');
    localStorage.removeItem('sms_user');
    localStorage.removeItem('sms_avatar_color_v2');
    setUser(null);
    setAvatarColor(null);
  }, []);

  // Patches a subset of fields onto the cached user (e.g. after the profile
  // picture changes) without a full re-login.
  const patchUser = useCallback((patch) => {
    setUser(u => {
      if (!u) return u;
      const next = { ...u, ...patch };
      localStorage.setItem('sms_user', JSON.stringify(next));
      return next;
    });
  }, []);

  return (
    <AuthContext.Provider value={{ user, avatarColor, loading, login, logout, patchUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
